import React from 'react';
import { connect } from 'react-redux';

import { Parser } from 'html-to-react';

import Typography from '@mui/material/Typography';

import { getAbout } from 'reducers/selectors';

const About = ({ about }) => {
    return (
        <div className="about-content">
            <Typography
                sx={{ color: '#000000' }}
                variant="subtitle1"
                id="tableTitle"
                component="div"
                className="mb-4"
            >
                {Parser().parse(about)}
            </Typography>
        </div>
    );
};

export default connect(state => {
    return {
        about: getAbout(state),
    };
}, null)(About);
